export enum OrdersTab {
  CURRENT = "current",
  COMPLETED = "completed",
}
